import _ from "lodash";
import $fp from '@fingerprintjs/fingerprintjs';

import {$api, HttpStatus} from "@isudio/core";
import {config, ipLookup} from "@isudio/config";
import {$store} from "@isudio/globals";
import {getDeviceInfo} from "./device";

export const setCountries = async (): Promise<void> => {
  const res = await $api.get(config.data.countries);
  if (_.get(res, 'data.length', 0) > 0) {
    const countries = _.sortBy(_.omitBy(_.get(res, 'data'), c => _.isNil(_.get(c, 'code.phone'))));
    const value: any = {};
    _.set(value, 'filter', _.crossFilter(countries));
    _.set(value, 'dimensions.code.phone', value.filter.dimension((o: any) => o.code.phone));
    _.set(value, 'dimensions.code.short2', value.filter.dimension((o: any) => _.toLower(o.code.short2)));
    _.set(value, 'dimensions.code.short3', value.filter.dimension((o: any) => _.toLower(o.code.short3)));
    _.set(value, 'dimensions.name.english', value.filter.dimension((o: any) => _.toLower(o.name.english)));
    _.set(value, 'dimensions.name.translated', value.filter.dimension((o: any) => _.toLower(o.name.translated)));
    _.set(value, 'dimensions.states', value.filter.dimension((o: any) => _.get(o, 'states', []), true));
    _.set(value, 'dimensions.units.currency.code', value.filter.dimension((o: any) => {
      if (_.has(o, 'units.currency.code')) {
        return o.units.currency.code;
      }
    }));
    _.set(value, 'default', _.find(countries, {code: {short2: 'US'}}));
    (_.get($store, 'Data.countries$') as any)?.next(value);
  }

  let data = null;

  for (let i = 0; i < ipLookup.length; i++) {
    const url = _.get(ipLookup, `[${i}].url`);
    const keys = _.get(ipLookup, `[${i}].keys`);
    const res = await $api.get(url);
    if (_.get(res, 'status') === HttpStatus.OK) {
      data = res.data;
      _.set($store, 'Device.data.network', {
        ip: _.get(data, keys.ip, null)
      });

      const countryCode = _.get(data, keys.country, 'US');
      const country = getCountryByCode(_.toLower(countryCode));

      let location = {};
      if (!_.isNothing(data, 'loc')) {
        const loc = _.split(_.get(data, 'loc'), ',');
        _.set(location, 'latlng', {
          lat: _.get(loc, '[0]'),
          lng: _.get(loc, '[1]')
        });

      } else {
        if (!_.isNothing(data, 'latitude') && !_.isNothing(data, 'longitude')) {
          _.set(location, 'latlng', {
            lat: _.get(data, 'latitude'),
            lng: _.get(data, 'longitude')
          });
        }
      }

      _.set(location, 'geoCode.country', country);
      if (!_.isNothing(data, keys.city)) _.set(location, 'geoCode.city', _.get(data, keys.city));
      if (!_.isNothing(data, keys.state)) _.set(location, 'geoCode.state', _.get(data, keys.state));

      _.set($store, 'Device.data.location', location);

      break;
    }
  }

  await $fp.load().then(async (fp) => {
    const result = await fp.get();
    const device = getDeviceInfo();
    const info  = {
      uuid: result.visitorId,
      ...device,
      fingerprint: result
    };

    _.set($store, 'Device.data.info', info);
  });

  return;
}

export const resetCountries = () => {
  const countries$: any = _.get($store, 'Data.countries$.value');
  _.each(['code.phone', 'code.short2', 'code.short3', 'name.english', 'name.translated', 'states', 'units.currency.code'], (c) => {
    if (!countries$) _.get(countries$, `dimensions.${c}`)?.filterAll();
  });
}

export const getCountries = (list: 'full' | 'short' = 'short'): any[] => {
  resetCountries();
  const countries$: any = _.get($store, 'Data.countries$.value');
  return (list === 'full' ? countries$.filter.all() :
      countries$.filter.all().map((c: any) => {
        return {
          code: c.code.short2.toLowerCase(),
          name: c.name.english,
          dialCode: c.code.phone,
          imageUrl: `/assets/fonts/flag-icons/flags/png/${c.code.short2.toLowerCase()}.png`
        }
      })
  );
}

export const getCountryByCode = (code: string): any => {
  resetCountries();
  const countries$: any = _.get($store, 'Data.countries$.value');
  const d = _.get(countries$, 'dimensions.code.short2');
  const f = d.filterFunction((o: any) => o === code);
  return f.top(1)[0];
}

export const getCountryByPhone = (phone: string): any => {
  let _country: any;
  resetCountries();
  const countries$: any = _.get($store, 'Data.countries$.value');
  const d = _.get(countries$, 'dimensions.code.short2');
  const f = d.filterFunction((o: any) => o === 'US');
  const _US = f.top(1)[0];

  if (_.isNothing(phone)) {
    _country = _.get($store, 'Device.data.location.geoCode.country', null);

  } else {
    if (phone.substring(0, 1) === '1') {
      if (phone.length < 4) {
        _country = _US;

      } else {
        resetCountries();
        const p = _.get(countries$, 'dimensions.code.phone');
        const s = _.get(countries$, 'dimensions.states');
        p.filterAll();
        s.filterAll();
        const sf = d.filterFunction((o: any) => o === phone.substring(1, 4));

        _country = sf.top(1)[0];
        _country = (_.isNothing(_country) ? _US : _country);
      }

    } else {
      resetCountries();
      const p = _.get(countries$, 'dimensions.code.phone');
      p.filterAll();
      const pf = p.filterFunction((o: any) => _.startsWith(phone, o));
      _country = pf.top(1)[0];
    }
  }
  return _country;
}